<template>
    <el-dialog title="接收方短信回复" :visible.sync="SmsRepayWin" append-to-body>
        <el-table v-loading="Smsloading" :data="SmsRepayData" :header-cell-style="{background:'#EEEFF4',color:'#888888',width: '100%'}">
            <el-table-column prop="receivetime" label="回复时间" align="center">
                <template slot-scope="scope">
                    {{scope.row.receivetime | dateTime(1)}}
                </template>
            </el-table-column>
            <el-table-column prop="content" label="回复内容" align="center"></el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="SmsRepayWin = false">返 回</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        props:{
            smsRepayObj:{
                type: Object
            }
        },
        data(){
            return{
                //接收方短信回复
                SmsRepayWin: false,
                SmsRepayData: [],
                Smsloading: false,
            }
        },
        methods:{
            
        },
        mounted(){
            
        },
        watch:{
            smsRepayObj: {
                handler(newVal, oldVal){
                    this.SmsRepayWin = this.smsRepayObj.SmsRepayWin;
                    this.SmsRepayData = this.smsRepayObj.SmsRepayData;
                    this.Smsloading = this.smsRepayObj.Smsloading;
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/SmsRepay.vue